<template functional>
  <section
    :class="['crm-block', data.staticClass]"
    :style="{
      'box-shadow': `0px 2px 10px 0px ${ props.backgroundColor || '#FFF' }`,
      'background-color': props.backgroundColor,
      'background-image': `url(${props.backgroundImage})`,
      'background-size': '100% 100%',
    }">
    <div class="crm-block_tip">
      <img width="20" height="20" :src="props.tipIcon" alt="icon">
      <span>&nbsp;&nbsp;</span>
      <span>{{ props.tipText }}</span>
    </div>
    <div class="crm-block_theme">
      <strong>{{ props.theme }}</strong>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    backgroundImage: String,
    backgroundColor: String,
    tipIcon: String,
    tipText: String,
    theme: [String, Number],
  },
};
</script>

<style lang="less" scoped>
.crm-block {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width:160px;
  height:80px;
  color: #FFF;
  border-radius:4px;
  &_tip {
    display: flex;
    justify-content: center;
    line-height: 20px;
    font-weight: 500;
    color: inherit;
  }
  &_theme {
    display: flex;
    justify-content: center;
    line-height: 28px;
    font-size: 24px;
    color: inherit;
  }
}
</style>
